import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1052332c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-md title" }
const _hoisted_2 = ["id"]

import { useStorePuzzle } from '@/stores/puzzle'
import { PuzzleVideo } from '@/types/Puzzle'
import PuzzleVideoCard from './PuzzleVideoCard.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    puzzleVideo: null,
    id: null
  },
  emits: ['ondrop', 'onDragOver'],
  setup(__props: any, { emit }) {

const props = __props as {
  puzzleVideo: PuzzleVideo
  id: number
}



const puzzleStore = useStorePuzzle()



function allowDrop(ev: Event) {
  emit('onDragOver', ev)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function drop(ev: any) {
  emit('ondrop', ev)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('puzzle.extract', [props.id])), 1),
    _createElementVNode("div", {
      class: "puzzle-extract-placeholder",
      id: `puzzle-extract-placeholder-${props.id}`,
      ondrop: drop,
      ondragover: allowDrop
    }, [
      (!_unref(puzzleStore).showJustification)
        ? (_openBlock(), _createBlock(PuzzleVideoCard, {
            key: 0,
            "puzzle-video": props.puzzleVideo,
            draggable: !_unref(puzzleStore).showJustification
          }, null, 8, ["puzzle-video", "draggable"]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ], 64))
}
}

})